import React, { useState, useMemo } from "react";
import styles from "./styles.module.scss";
import Banner from "@assets/img/sliderBanner.png";
import WelcomeSliderBtn from "@assets/icons/welcomeSliderBtn";

const Slider: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const length = 10;

  const slides = useMemo(
    () =>
      Array.from({ length }, (_, i) => ({
        id: `slide-${i}`,
      })),
    [length],
  );

  const nextSlide = () => {
    setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <div className={styles.slider}>
      <button
        type="button"
        className={styles.leftArrow}
        onClick={prevSlide}
        aria-label="Previous slide"
      >
        <div className={styles.iconWrapper}>
          <WelcomeSliderBtn />
        </div>
      </button>
      <button
        type="button"
        className={styles.rightArrow}
        onClick={nextSlide}
        aria-label="Next slide"
      >
        <div className={styles.iconWrapper}>
          <WelcomeSliderBtn />
        </div>
      </button>
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`${styles.slide} ${
            index === current ? styles.slideActive : ""
          }`}
        >
          {index === current && (
            <div className={styles.imgContainer}>
              <img src={Banner} alt={`Slide ${index + 1}`} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Slider;
